import { useState, useCallback } from "react";
import { filtersInitialState } from "../store/shared/filters/filtersState";

/**
 * Local filter state hook that replaces Zustand-persisted filter state.
 * Provides the same interface as makeFiltersActions but backed by useState,
 * so filters reset on unmount (page navigation).
 *
 * @param {Object} defaults - Default filter values passed to filtersInitialState()
 *   e.g. { status: "0" } for drafts, { status: "2" } for submits
 * @returns {{ filters, updateFilter, clearFilters }}
 */
export const useFilters = (defaults = {}) => {
  const [filters, setFilters] = useState(() => filtersInitialState(defaults));

  const updateFilter = useCallback((partial) => {
    setFilters((prev) => ({ ...prev, ...partial }));
  }, []);

  const clearFilters = useCallback(() => {
    const cleared = filtersInitialState(defaults);
    setFilters(cleared);
    return cleared;
  }, []);

  return { filters, updateFilter, clearFilters };
};
